<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Broadcast Performance</div>
    <div class="divider"></div>
    <div class="filter">
      <button mat-button class="icon-btn" (click)="toggleFilterDialog()">
        <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
      </button>
    </div>
    <div class="divider"></div>
    <div class="dates">
      <div class="date start-date">
        <div class="text">Start</div>
        <button
          mat-button
          class="icon-btn"
          (click)="startDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #startDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="startDate"
        >
        </lhpe-datepicker>
      </div>
      <div class="date end-date">
        <div class="text">End</div>
        <button
          mat-button
          class="icon-btn"
          (click)="endDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #endDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="endDate"
        >
        </lhpe-datepicker>
      </div>
    </div>

    <div class="divider"></div>
    <div class="search-box input-box">
      <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

      <mat-form-field>
        <input
          matInput
          (keyup)="applyFilter()"
          matInput
          type="text"
          [(ngModel)]="searchValue"
        />
      </mat-form-field>
    </div>
  </div>
  <div class="header-center"></div>
  <div class="header-right"></div>
</div>
<div class="broadcast-performance">
  <div class="container broadcasts-container">
    <div class="container-header no-bottom-border">
      <div class="text">Broadcasts</div>
      <div class="options">
        <button mat-icon-button [matMenuTriggerFor]="broadcastsMenu">
          <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
        </button>
        <mat-menu class="mat-menu-elaphant" #broadcastsMenu="matMenu">
          <button
            class="icon-btn-w-text"
            mat-menu-item
            (click)="exportToExcel()"
          >
            <svg-icon src="assets/svg/sheet.svg" svgClass="white"></svg-icon>
            <span>Export to Excel</span>
          </button>
        </mat-menu>
      </div>
    </div>
    <div class="container-content">
      <table
        #broadcastsTable
        mat-table
        [dataSource]="broadcastsDataSource"
        matSort
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let row">
            {{ row.name ? row.name : "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="send_date_time">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Date & Time Sent
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.send_date_time">
              {{ formatDate(row.send_date_time) }}
            </ng-container>
            <ng-container *ngIf="!row.send_date_time"> - </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="sent">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Recipients</th>
          <td mat-cell *matCellDef="let row">
            {{ row.sent ? row.sent : "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="tracking_window">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Tracking window
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.tracking_window }}
            {{ row.tracking_window === 1 ? "day" : "days" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="conversions_total">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Conversions</th>
          <td mat-cell *matCellDef="let row">
            {{ row.conversions_total }}
          </td>
        </ng-container>

        <ng-container matColumnDef="conversion_pct">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Conversion Pct
          </th>
          <td mat-cell *matCellDef="let row">{{ row.conversion_pct }}%</td>
        </ng-container>

        <ng-container matColumnDef="conversion_rank">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Conversion Rank
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.conversion_rank }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="onBroadcastClicked(row)"
          class="clickable-row"
          [ngClass]="{ selected: selectedBroadcast?.id === row.id }"
        ></tr>
      </table>
    </div>
  </div>

  <!-- TODO -->
  <div *ngIf="false" class="container performance-container">
    <div class="container-header no-bottom-border">
      <div class="text">
        Tracking window performance for <b>{{ selectedBroadcast.name }}</b>
      </div>
      <div class="options">
        <button mat-icon-button [matMenuTriggerFor]="performanceMenu">
          <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
        </button>
        <mat-menu
          class="mat-menu-elaphant vertical-menu"
          #performanceMenu="matMenu"
        >
        </mat-menu>
      </div>
    </div>
    <div class="container-content">
      <div
        *ngIf="selectedBroadcast"
        echarts
        [options]="options"
        class="demo-chart"
      ></div>
    </div>
  </div>
</div>
